import { Controller } from '@hotwired/stimulus'

// Presets fill the date fields. The download buttons submit those fields.
export default class extends Controller {
  static targets = ['preset', 'from', 'to']
  static values = { ranges: Object }

  preset (event) {
    const range = this.rangesValue[event.params.name]
    if (!range) {
      return
    }

    this.fromTarget.value = range[0]
    this.toTarget.value = range[1]
    this.mark(event.params.name)
  }

  custom () {
    this.mark(null)
  }

  mark (name) {
    this.presetTargets.forEach((button) => {
      button.classList.toggle('active', button.dataset.name === name)
    })
  }
}
